import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/ameliyatsiz-yuz-germe-yontemleri/page.tsx");
